module.exports = __webpack_public_path__ + "img/financial.c486a4b5.svg";